import React from "react";

interface Props extends React.SVGProps<SVGSVGElement> {
  width?: string | number;
  height?: string | number;
}

const ClosegreyBGSvg: React.FC<Props> = ({ width = 24, height = 24, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4152_117668)">
      <circle cx="12" cy="12" r="12" fill="#52575D" fillOpacity="0.7" />
      <path
        d="M15.711 8.28906L8.29102 15.7091"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M8.29102 8.28906L15.711 15.7091"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_117668">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ClosegreyBGSvg;
